import React from 'react';
import { FormattedMessage } from 'react-intl';

import messages from './messages';

import { Button, ActiveButton } from './Buttons';
import { Container, SegmentContainer } from './Containers';
import DonutPieChart from '../DonutPieChart';

const MainView = ({ segments, selectedSegment = null, openDetailedView }) => {
    const onClickViewDetails = (event) => {
        openDetailedView(event.currentTarget.value);
    };

    return (
        <Container>
            {segments.map(({ key, title, segmentsSummary }) => {
                const ButtonComponent = selectedSegment === key ? ActiveButton : Button;
                return (
                    <SegmentContainer key={key}>
                        <DonutPieChart title={title} data={segmentsSummary} />
                        <ButtonComponent onClick={onClickViewDetails} value={key}>
                            <FormattedMessage {...messages.viewDetailsBtn} />
                        </ButtonComponent>
                    </SegmentContainer>
                );
            })}
        </Container>
    );
};

export default MainView;
